import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const GENERAL_EXPENSE_ENDPOINT = '/general-expense';

export class GeneralExpenseService extends RestServiceConnection {

    listGeneralExpenses = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: GENERAL_EXPENSE_ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getGeneralExpenseById = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: GENERAL_EXPENSE_ENDPOINT + '/get',
            data: { id },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    createGeneralExpense = async (data: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: GENERAL_EXPENSE_ENDPOINT + '/create',
            data: data,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    editGeneralExpense = async (data: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: GENERAL_EXPENSE_ENDPOINT + '/edit',
            data: data,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    deleteGeneralExpense = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: GENERAL_EXPENSE_ENDPOINT + '/delete',
            data: { id },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    getStats = async (data?: { dateFrom?: string; dateTo?: string; company?: string }) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: GENERAL_EXPENSE_ENDPOINT + '/stats',
            data: data ?? {},
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES IMPORTA GASTOS GENERALES DESDE UN EXCEL
     * @EN IMPORTS GENERAL EXPENSES FROM AN EXCEL FILE
     */
    // -------------------------------------------------------------------------------------------------------------
    importExcel = async (formData: FormData) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: GENERAL_EXPENSE_ENDPOINT + "/import",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}
